import { alpha, css, styled } from '@mui/material/styles';

import { containerLargeWidth, rem, Theme } from '../../theme';
import { ButtonBase } from '../Button';
import { ButtonProperties } from '../Button/base/Button.types';
import { Heading } from '../Heading';
import { ImageStandalone } from '../ImageStandalone';

import { RoundelPosition } from './HeroWithOverlay.types';

export const StyledWrapper = styled('div')`
    position: relative;
    line-height: 0;
`;

export const StyledLabel = styled('div')`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_14_bold_desktop_18};
    text-transform: lowercase;
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing(0, 0)};
        color: ${theme.palette.common.white};
	`}
`;

export const StyledButton = styled(ButtonBase)<ButtonProperties>`
    ${({ theme }) => theme.typography.text_18_bold_desktop_19};
    ${({ theme }) => `
        width: 100%;
        margin: ${theme.tggSpacing([rem(0.5), 0], [1.25, 0])};

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing('auto', 'auto')};
            margin: ${theme.tggSpacing([rem(1.5), rem(1), rem(1.5), 0], [3.75, 2.5, 3.75, 0])};
        }
	`}
`;

export const StyledHeadingUnderlay = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        width: 100%;
        margin-top: ${theme.tggSpacing('auto', 'auto')};
        line-height: ${theme.tggSpacing(rem(1.8), 7)};
        background: ${alpha(theme.palette.primary.main, 0.9)};

        ${theme.breakpoints.up('desktop')} {
            line-height: ${theme.tggSpacing(rem(2.2), 9)};
        }
	`}
`;

export const StyledHeadingContent = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        max-width: ${theme.tggSpacing(rem(containerLargeWidth), 211.25)};
        padding: ${theme.tggSpacing([rem(1.5), rem(3)], [3.75, 7.5])};
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
	`}
`;

export const StyledImageStandalone = styled(ImageStandalone)`
    ${({ theme }: { theme: Theme }) =>
        theme.breakpoints.up('extraLargeDesktop')} {
        min-height: 65vh;
    }
`;

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        position: absolute;
        top: ${theme.tggSpacing(0, 0)};
        right: ${theme.tggSpacing(0, 0)};
        bottom: ${theme.tggSpacing(0, 0)};
        left: ${theme.tggSpacing(0, 0)};
        display: flex;
        flex-direction: column;
	`}
`;

export const StyledRoundelContainer = styled('div')`
    position: relative;
    flex-grow: 1;
`;

export const StyledRoundel = styled(ImageStandalone)<{
    position: RoundelPosition;
}>`
    ${({ theme, position }) => css`
        position: absolute;
        width: auto;
        max-width: 50%;
        max-height: 50%;

        ${position === 'center right'
            ? css`
                  top: 50%;
                  right: 10%;
                  transform: translateY(-50%);
              `
            : css`
                  top: 10%;
                  right: 10%;
              `}

        ${theme.breakpoints.up('largeDesktop')} {
            max-width: ${theme.tggSpacing(rem(40), 100)};
            max-height: 60%;
        }
    `}
`;
